import { Injectable } from 'angular-ts-decorators';

import { CurrentSession } from '@shared/app/scripts/services/current-session';
import { find, includes, some } from 'lodash';

/**
 * Service to check applications permissions for a current user
 */
@Injectable('applicationAuthorization')
export class ApplicationAuthorization {
  constructor(
    private currentSession: CurrentSession,
    private appName,
  ) {
    'ngInject';
  }

  /**
   *
   * Remove the logo image.
   * @param {string} application
   * Application to be checked, defaults to {@link coreModule.appName}
   * @returns {Boolean}
   * True if current user can access the application
   */
  hasAccess(application: string = this.appName): boolean {
    if (application === 'my') {
      let roles = this.currentSession.roles[this.currentSession.tenantId];

      return some(['owner', 'account-admin', 'account-user'], (el) =>
        includes(roles, el),
      );
    }

    if (application === 'admin') {
      return !!find(this.currentSession.availableTenants, { id: 'master' });
    }

    return !!this.currentSession.applications[application];
  }
}
